// DateFieldComponent.js
import React, { useState, useEffect } from "react";
import { TextField } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { getLocalizedFieldLabel } from "../helpers/helpers";
import "./components.css";

export default function DateFieldComponent({ questionKey, value, onChange, label, lang }) {

  const [selectedDate, setSelectedDate] = useState(value || null);

  useEffect(() => {
    setSelectedDate(value || null);
  }, [value]);

  const handleDateChange = (newValue) => {
    setSelectedDate(newValue);
    if (onChange) onChange(questionKey, newValue);
  };

  return (
    <div className="flexAlignColumnClassName">
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <DatePicker
          label={getLocalizedFieldLabel(questionKey, lang) || label}
          value={selectedDate}
          onChange={handleDateChange}
          inputFormat="MM/dd/yyyy"
          mask="__/__/____"
          renderInput={(params) => (
            <TextField
              {...params}
              fullWidth
              className="numberFieldInputComponent"
              variant="outlined"
              placeholder="MM/DD/YYYY"
              inputProps={{
                ...params.inputProps,
                placeholder: "MM/DD/YYYY",
              }}
              InputLabelProps={{
                classes: {
                  root: "outlinedInputLabel",
                  focused: "focusedInputLabel",
                },
              }}
              InputProps={{
                ...params.InputProps,
                classes: {
                  root: "outlinedInputRoot",
                  focused: "outlinedInputFocused",
                  notchedOutline: "outlinedInput",
                },
              }}
            />
          )}
        />
      </LocalizationProvider>
    </div>
  );
}